import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const TopSlider = () => {
    return (
        <div className="top-slider">
            <div className="d-none d-lg-block">
                <div id="top-slider-wrapper" className="top-slider-wrapper position-relative">
                    <div className="container">
                        <div className="top-slider-content xmb-6 xp-2">
                            <div className="swiper mySwiper2">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide" data-color="#000">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide"
                                         data-image="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#000">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#ffcccc">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#000">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#ffcccc">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#000">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#ffcccc">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#000">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#ffcccc">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#000">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide" data-color="#000">
                                        <div className="row">
                                            <div className="col-5 col-xl-4">
                                                <div className="text-product">
                                                    <h2>Galaxy Note 20
                                                        Ultra buds Live</h2>
                                                    <p>فرصت طلایی برای پیش-خرید در سایمان دیجیتال</p>
                                                    <a href="#">بررسی و خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-7 col-xl-8">
                                                <div className="img-gallery">
                                                    <a href="#">
                                                        <img
                                                            src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png"
                                                            alt="galaxynote20ultra" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="thumbnail-slide position-relative">
                            <div className="swiper-button-prev"/>
                            <div className="swiper-button-next" id="next-button-top-slide"/>
                            <div className="swiper swiper-gallery">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide">
                                        <img
                                            src="./assets/sample-image/samsung-galaxy-note-20-ultra-buds-live_Image_minify.png"
                                            alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-4a-head_Image_minify.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-1.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-2.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-3.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-4.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-5.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-6.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-7.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-8.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-9.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-10.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-10.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-10.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-10.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-10.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-10.png"
                                             alt="note20 ultra"/>
                                    </div>
                                    <div className="swiper-slide">
                                        <img src="./assets/sample-image/google-pixel-10.png"
                                             alt="note20 ultra"/>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*header slider responseve*/}
            <div className="d-block d-lg-none">
                <div className="slider-header-responsive-wrapper position-relative">
                    <div className="swiper header-slider-responsive xmx-2">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <a href="#">
                                    <div className="slide-box position-relative d-flex justify-content-center">
                                        <img src="./assets/sample-image/MicrosoftTeams-image.png"
                                             alt="galaxynote20ultra"/>
                                        <h2 className="position-absolute">Galaxy Note20 Ultra</h2>
                                        <div className="info-product position-absolute">
                                            <h2>Galaxy Note 20 Ultra buds Live</h2>
                                            <p>دوربین پنج‌گانه ۱۰۸ مگاپیکسلی</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="swiper-slide">
                                <a href="#">
                                    <div className="slide-box position-relative d-flex justify-content-center">
                                        <img src="./assets/sample-image/MicrosoftTeams-image.png"
                                             alt="galaxynote20ultra"/>
                                        <h2 className="position-absolute">Galaxy Note20 Ultra</h2>
                                        <div className="info-product position-absolute">
                                            <h2>Galaxy Note 20 Ultra buds Live</h2>
                                            <p>دوربین پنج‌گانه ۱۰۸ مگاپیکسلی</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="swiper-slide">
                                <a href="#">
                                    <div className="slide-box position-relative d-flex justify-content-center">
                                        <img src="./assets/sample-image/MicrosoftTeams-image.png"
                                             alt="galaxynote20ultra"/>
                                        <h2 className="position-absolute">Galaxy Note20 Ultra</h2>
                                        <div className="info-product position-absolute">
                                            <h2>Galaxy Note 20 Ultra buds Live</h2>
                                            <p>دوربین پنج‌گانه ۱۰۸ مگاپیکسلی</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-pagination"/>
                </div>
            </div>
            {/*end header wrapper slider*/}

            {/*links slider header*/}
            <div className="d-block d-lg-none">
                <div className="container">
                    <div className="links-slider-responsive xpt-6 xpb-6">
                        <div className="swiper link-slider-responsive">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="icon-slider"><IconName name="phone" className="icon"/></div>
                                        <div className="text-slider"><span>گوشی موبایل</span></div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="icon-slider"><IconName name="laptop" className="icon"/></div>
                                        <div className="text-slider"><span>تبلت و لپ تاپ</span></div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="icon-slider"><IconName name="watch" className="icon"/></div>
                                        <div className="text-slider"><span>ساعت هوشمند</span></div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="icon-slider"><IconName name="home" className="icon"/></div>
                                        <div className="text-slider"><span>خانه هوشمند</span></div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="icon-slider"><IconName name="phone" className="icon"/></div>
                                        <div className="text-slider"><span>گوشی موبایل</span></div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="icon-slider"><IconName name="phone" className="icon"/></div>
                                        <div className="text-slider"><span>گوشی موبایل</span></div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="icon-slider"><IconName name="phone" className="icon"/></div>
                                        <div className="text-slider"><span>گوشی موبایل</span></div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div className="icon-slider"><IconName name="phone" className="icon"/></div>
                                        <div className="text-slider"><span>گوشی موبایل</span></div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*end links slider header*/}
        </div>
    );
};

export default TopSlider;
